import { render, staticRenderFns } from "./ai_genie_chat_message_sources.vue?vue&type=template&id=13dca380&"
import script from "./ai_genie_chat_message_sources.vue?vue&type=script&lang=js&"
export * from "./ai_genie_chat_message_sources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports